import type { CardData, Connection } from '../types/card';

export const CANCELLED_PROGRAM_INFO_BOX_IDS = new Set([
  'vsm-comm-supplier-fax',
  'vsm-comm-weekly-program',
  'vsm-comm-daily-program',
]);

const normalize = (value: unknown) => String(value ?? '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase();

export function isCancelledProgramInfoText(value: unknown): boolean {
  const text = normalize(value).replace(/\s+/g, ' ').trim();
  return /programa\s+(semanal|diario)/.test(text);
}

export function isCancelledProgramInfoCard(card?: CardData | null): boolean {
  if (!card) return false;
  if (CANCELLED_PROGRAM_INFO_BOX_IDS.has(card.id)) return true;

  return String((card as any).vsmIcon ?? '') === 'comunicacao' && (
    isCancelledProgramInfoText(card.atividade) ||
    isCancelledProgramInfoText((card as any).vsmInfoTitle) ||
    isCancelledProgramInfoText((card as any).nome_fluxo)
  );
}

export function shouldRemoveCancelledProgramInfoConnection(conn: Connection, target?: CardData | null): boolean {
  return CANCELLED_PROGRAM_INFO_BOX_IDS.has(conn.targetId) ||
    isCancelledProgramInfoText((conn as any).vsmInfoTitle) ||
    isCancelledProgramInfoCard(target);
}